exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.time-popover {\r\n  padding: 0;\n}\n.monitor-yt-popover {\r\n  background: #edf5ff;\r\n  border: 1px solid #97c3ff;\r\n  padding: 11px 15px 0px 15px;\n}\r\n", ""]);

// exports
